const languageToDatoLocale = {
  en: 'en',
  da: 'da',
  nl: 'nl',
  fr: 'fr',
  de: 'de',
  it: 'it',
  no: 'no',
  ru: 'ru',
  sv: 'sv',
  es: 'es',
  pt: 'pt_BR',
} as const

export default languageToDatoLocale

export const datoLocaleToLanguage = {
  en: 'en',
  da: 'da',
  nl: 'nl',
  fr: 'fr',
  de: 'de',
  it: 'it',
  no: 'no',
  ru: 'ru',
  sv: 'sv',
  es: 'es',
  pt_BR: 'pt',
} as const
